import { IMAGES } from "@/lib/data";

export default function ComingSoon() {
  return (
    <div className="fixed inset-0 overflow-hidden bg-[#f5f3de]" data-testid="coming-soon">
      {/* Sunset harbour hero background — same as the top of the site */}
      <img src={IMAGES.hero} alt="Diamond Harbour at sunset" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/10 to-black/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />

      {/* Logo + Coming Soon */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <img
          src="/hero-haze.png"
          alt="Harbour Haze Cafe Bar"
          className="w-[86vmin] h-[86vmin] max-w-[620px] max-h-[620px] object-contain drop-shadow-2xl"
        />
        <p
          data-testid="coming-soon-text"
          className="-mt-4 md:-mt-8 font-head font-black tracking-tight text-white text-[13vw] sm:text-6xl lg:text-7xl [text-shadow:0_4px_30px_rgba(0,0,0,0.6)]"
        >
          Coming Soon
        </p>
      </div>
    </div>
  );
}
